import { render, staticRenderFns } from "./MainHistorico.vue?vue&type=template&id=3d2a10ea&scoped=true"
import script from "./MainHistorico.vue?vue&type=script&lang=js"
export * from "./MainHistorico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2a10ea",
  null
  
)

export default component.exports